import { Alert, CircularProgress } from "@mui/material";
import { PropsWithChildren } from "react";
import { usePortraitsTranslator } from "../i18n/translator";
import { useGetMe } from "../useGetMe";

export const RequireAdmin = ({ children }: PropsWithChildren) => {
  const translator = usePortraitsTranslator();
  const { data: me, isError } = useGetMe();

  if (isError) {
    return (
      <Alert severity="error">{translator("unknownErrorTryAgainLater")}</Alert>
    );
  }
  if (!me) {
    return <CircularProgress aria-busy />;
  }
  return me.isAdmin ? (
    children
  ) : (
    <Alert severity="warning">{translator("adminsOnly")}</Alert>
  );
};
